import React, { FunctionComponent } from 'react';
import { TableColumn } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';

// Components
import GenericTable from 'components/Table/GenericTable';
import CommonIcon from 'components/CommonIcon';
import { SeasonPhaseType } from './SeasonSubscriptionInfo';
import { Wrapper } from '../components/PricesTable';

const StyledSpan = styled.span`
  vertical-align: text-top;
`;

interface OwnProps {
  seasonPhases: Array<SeasonPhaseType>;
  onEditClick: Function;
}

type Props = OwnProps;

const SeasonPhasesTable: FunctionComponent<Props> = ({ seasonPhases, onEditClick }) => {
  const generateColumns = (): Array<TableColumn<SeasonPhaseType>> => [
    {
      title: 'Starts at',
      key: '',
      render: ({ rowValues }) => {
        const { startsAt } = rowValues;
        return <>{startsAt.format('YYYY/MM/DD HH:mm')}</>;
      },
    },
    {
      title: 'Expires at',
      key: '',
      render: ({ rowValues }) => {
        const { expiresAt } = rowValues;
        return <>{expiresAt.format('YYYY/MM/DD HH:mm')}</>;
      },
    },
    {
      title: 'Next rebill price',
      key: 'seasonPrice',
    },
    {
      title: 'Current price',
      key: 'currentPrice',
    },
  ];

  const handleEditPhase = ({ row }: any) => {
    onEditClick(row);
  };

  const renderRowActions = (): any => [
    {
      render: ({ row }: any) => (
        <StyledSpan>
          <CommonIcon
            tag={`icon_edit_${row.id}`}
            name="edit"
            hoverStatus="edit"
            onClick={(e) => {
              e.preventDefault();
              handleEditPhase({ row });
            }}
          />
        </StyledSpan>
      ),
    },
  ];

  return (
    <Wrapper>
      <GenericTable<SeasonPhaseType>
        columns={generateColumns()}
        data={seasonPhases}
        showLoader={false}
        options={{
          rowActions: renderRowActions(),
        }}
        type="phases"
        actionsRowTitle="Edit"
        noDataMessage="You must add one phase in order to complete the adding of the season access fee."
      />
    </Wrapper>
  );
};

export default SeasonPhasesTable;
